import { Separator } from './styles';
export default Separator;
